// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3ogTw","spinner":"styles_spinner__28i9O","spin":"styles_spin__1lOk2","withoutPosition":"styles_withoutPosition__3IWsr"};